import { isEdmGuid } from "@sg-protect/core";
import { generatePath } from "react-router";
import { usePaths } from "../../paths.ts";
import { useDetailsOriginQuery } from "../useDetailsOriginQuery.ts";

const tabPathKeys = {
    overview: "userDetailsOverview",
    sharingLinks: "userDetailsSharingLinks"
} as const;

export type UserDetailsTab = keyof typeof tabPathKeys;

export function useUserDetailsHref() {
    const paths = usePaths();
    const query = useDetailsOriginQuery();

    return (userId?: string, tab: UserDetailsTab = "overview") => {
        if (!isEdmGuid(userId)) {
            return undefined;
        }

        const queryString = query.size ? `?${query.toString()}` : "";

        return `${generatePath(paths[tabPathKeys[tab]], { userId })}${queryString}`;
    };
}
